import { render, staticRenderFns } from "./PermissionGroupList.vue?vue&type=template&id=4d484c46&"
import script from "./PermissionGroupList.vue?vue&type=script&lang=js&"
export * from "./PermissionGroupList.vue?vue&type=script&lang=js&"
import style0 from "./PermissionGroupList.vue?vue&type=style&index=0&id=4d484c46&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports